import React, { useContext } from 'react';
import {
	offer_icon,
	devis,
	signature,
	calendrier,
} from '../../../utils/images';
import { ExpertContext } from '../../Contexts/contexts';

function TopCardsExpert() {
	const expertContext = useContext(ExpertContext);

	return (
		<div className="top-cards-container">
			<div className="top-cards">
				<div className="top-cards-infos">
					<span className="top-cards-title">En attente d'acceptation</span>
					<img src={devis} className="top-cards-icons" alt="devis"></img>
				</div>
				<div>
					<span className="top-cards-number">
						{expertContext?.getClientExpertRelationsByStatus([0, 1]).length}
					</span>
					<span className="top-cards-details"></span>
				</div>
				<div className="top-cards-color-line yellow-line"></div>
			</div>
			<div className="top-cards">
				<div className="top-cards-infos">
					<span className="top-cards-title">Rendez-vous</span>
					<img
						src={calendrier}
						className="top-cards-icons grey-filter"
						alt="calendrier"
					></img>
				</div>
				<div>
					<span className="top-cards-number">
						{expertContext?.getClientExpertRelationsByStatus([1, 2]).length}
					</span>
					<span className="top-cards-details"></span>
				</div>
				<div className="top-cards-color-line purple-line"></div>
			</div>
			<div className="top-cards">
				<div className="top-cards-infos">
					<span className="top-cards-title">Commissions à payer</span>
					<img
						src={signature}
						className="top-cards-icons grey-filter"
						alt="signature"
					></img>
				</div>
				<div>
					<span className="top-cards-number">
						{
							expertContext
								?.getClientExpertRelationsByStatus([3, 4])
								?.filter(
									(rel) =>
										(rel.status === 4 ||
											(rel.status === 3 && rel.expertSigned)) &&
										rel?.expertCommission?.finishedAt === null
								).length
						}
					</span>
					<span className="top-cards-details"></span>
				</div>
				<div className="top-cards-color-line blue-line"></div>
			</div>
			<div className="top-cards">
				<div className="top-cards-infos">
					<span className="top-cards-title">Historique client</span>
					<img
						src={offer_icon}
						className="top-cards-icons grey-filter"
						alt="cumul client"
					></img>
				</div>
				<div>
					<span className="top-cards-number">
						{
							expertContext
								?.getClientExpertRelationsByStatus([3, 4, 5, 6])
								?.filter(
									(rel) =>
										rel.status > 3 ||
										(rel.status === 3 && rel.expertSigned === 1)
								).length
						}
					</span>
					<span className="top-cards-details"></span>
				</div>
				<div className="top-cards-color-line green-line"></div>
			</div>
		</div>
	);
}

export default TopCardsExpert;
